/**
 * Formulario de Operarios de la VALIDACIÓN montado solo con lo que tiene el
 * servidor, para precargarlo en sessionStorage.
 *
 * El formulario de Operarios solo llegaba a sessionStorage si su pestaña se
 * montaba y algo cambiaba (o al pulsar «Continuar»). Quien saltaba a otra
 * pestaña antes —en la tablet, con la pestaña aún cargando— dejaba la clave
 * vacía y el envío reventaba (`JSON.parse(null).operatorsTable`). Ubicación y
 * Edición ya se precargaban así; Operarios no.
 *
 * La regla de la precarga: NO cambia lo que se guarda. Por eso `dataFromServer`
 * es el mismo formulario —el diff del envío sale vacío— y las fechas opcionales
 * vacías van como `''`, igual que en los `defaultValues` del formulario (el
 * esquema no acepta `null` en la fecha final). La fecha de INICIO no se
 * inventa: el formulario pone «ahora» si falta, pero eso guardaría una hora que
 * nadie ha visto; sin ella, «Validar» manda a Operarios a ponerla.
 *
 * Spec: docs/superpowers/specs/2026-10-07-wizard-tab-jump-design.md
 */
type OperatorsServerValues = {
  externalWorks?: unknown[];
  registerEndDate?: string | null;
  registerArrivalDate?: string | null;
  isSimultaneous?: boolean | null;
  [key: string]: unknown;
};

export const buildOperatorsFormFromServer = <T extends OperatorsServerValues>(
  values: T
) => {
  const form = {
    ...values,
    registerEndDate: values.registerEndDate || '',
    registerArrivalDate: values.registerArrivalDate || '',
    isSimultaneous: values.isSimultaneous ?? false,
    // El formulario las maneja como `externals` (igual que su loader).
    externals: [...(values.externalWorks ?? [])],
  };
  // Copia profunda: lo que se toque después en el formulario no puede
  // arrastrar la referencia con la que se compara.
  return { ...form, dataFromServer: structuredClone(form) };
};
